export { default } from './InteractWithContractContainer';
